
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"43","height":"52"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.91 51.188a.893.893 0 01-.565-.205.867.867 0 01-.071-1.202l2.651-3.056-.694-.018a20.37 20.37 0 01-2.15-.181 19.311 19.311 0 01-3.394-.757c-5.34-1.657-9.697-5.281-12.272-10.207-2.6-4.918-3.12-10.564-1.465-15.898a21.058 21.058 0 015.336-8.744 20.933 20.933 0 018.888-5.137.805.805 0 01.237-.037.86.86 0 01.811.614.838.838 0 01-.076.65.816.816 0 01-.508.389 19.427 19.427 0 00-8.166 4.732 18.978 18.978 0 00-4.898 8.025A19.079 19.079 0 004.896 34.77a19.124 19.124 0 0011.277 9.395 21.35 21.35 0 003.131.693c.692.093 1.407.15 2.19.175l.643.018-2.376-3.502a.84.84 0 01.224-1.179c.14-.092.3-.144.464-.144.278 0 .54.142.704.378l3.249 4.782a.85.85 0 01-.029 1.083l-3.835 4.435a.827.827 0 01-.629.285m7.373-5.321a.858.858 0 01-.812-.625.86.86 0 01.592-1.045 19.172 19.172 0 008.172-4.731 19.22 19.22 0 004.897-8.001 19.237 19.237 0 00-1.335-14.632c-2.395-4.544-6.4-7.875-11.278-9.38a18.599 18.599 0 00-3.136-.693 18.57 18.57 0 00-2.168-.172l-.634-.015 2.355 3.495c.13.19.177.42.132.645a.791.791 0 01-.342.512.84.84 0 01-1.18-.213l-3.25-4.798a.835.835 0 01.026-1.066L23.152.718a.84.84 0 01.638-.285c.205 0 .4.071.552.2.169.147.274.36.287.589a.8.8 0 01-.2.596l-2.656 3.05.682.029c.831.034 1.514.092 2.152.182a22.95 22.95 0 013.402.752c5.334 1.671 9.692 5.303 12.272 10.226 2.596 4.918 3.114 10.564 1.458 15.9a20.976 20.976 0 01-5.33 8.727 21.128 21.128 0 01-8.893 5.15.82.82 0 01-.234.034","fill":"#0A5792","fill-rule":"evenodd","stroke":"#0A5792","stroke-width":".4"}})])
          )
        }
      }
    